import React from 'react';
import CalculatorButton from './calculator-button';

const CalculatorButtonRow = ({ onSelect, buttons }) => {
  // a row with a single button (e.g. an odd one left over from a grid that doesn't divide
  // evenly) fills the row's width instead of sitting narrow-left with dead space beside it
  const fill = buttons.length === 1;

  return (
    <div style={{display: 'flex', width: '100%'}}>
      {buttons.map(button => (
        <CalculatorButton
          key={button}
          value={button}
          onSelect={onSelect}
          fill={fill}
        />
      ))}
    </div>
  );
};

export default CalculatorButtonRow;
